import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const AddProduct = () => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    price: "",
    category: "",
    images: [],
  });

  const [categories, setCategories] = useState([]);
  const [previewImages, setPreviewImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const navigate = useNavigate();

  // 🔹 Fetch all categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get("https://sonvika.hxbindia.com/api/categories");
        if (res.data.success) {
          setCategories(res.data.categories);
        } else {
          setErrorMsg("Failed to load categories.");
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
        setErrorMsg("Error fetching categories. Please try again.");
      }
    };
    fetchCategories();
  }, []);

  // 🔹 Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // 🔹 Handle image file input
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setFormData({ ...formData, images: files });

    // Generate image preview URLs
    const previews = files.map((file) => URL.createObjectURL(file));
    setPreviewImages(previews);
  };

  // 🔹 Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.category) {
      alert("Please select a category before submitting.");
      return;
    }

    const data = new FormData();
    data.append("name", formData.name);
    data.append("description", formData.description);
    data.append("price", formData.price);
    data.append("categoryId", formData.category);

    formData.images.forEach((image) => {
      data.append("images", image);
    });

    try {
      setLoading(true);
      setErrorMsg("");

      const res = await axios.post("https://sonvika.hxbindia.com/api/products", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.success) {
        alert("✅ Product added successfully!");
        setFormData({
          name: "",
          description: "",
          price: "",
          category: "",
          images: [],
        });
        setPreviewImages([]);
        navigate("/products");
      } else {
        setErrorMsg(res.data.message || "Failed to add product.");
      }
    } catch (error) {
      console.error("Error adding product:", error);
      setErrorMsg(error.response?.data?.message || error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Add Product</h2>

      {errorMsg && (
        <div className="alert alert-danger" role="alert">
          {errorMsg}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        {/* Product Name */}
        <div className="mb-3">
          <label className="form-label fw-semibold">Product Name</label>
          <input
            type="text"
            className="form-control"
            name="name"
            placeholder="Enter product name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        {/* Description */}
        <div className="mb-3">
          <label className="form-label fw-semibold">Description</label>
          <textarea
            className="form-control"
            name="description"
            placeholder="Enter product description"
            value={formData.description}
            onChange={handleChange}
            rows="4"
            required
          ></textarea>
        </div>

        {/* Price */}
        <div className="mb-3">
          <label className="form-label fw-semibold">Price (₹)</label>
          <input
            type="number"
            className="form-control"
            name="price"
            placeholder="Enter product price"
            value={formData.price}
            onChange={handleChange}
            required
          />
        </div>

        {/* Category */}
        <div className="mb-3">
          <label className="form-label fw-semibold">Category</label>
          <select
            className="form-select"
            name="category"
            value={formData.category}
            onChange={handleChange}
            required
          >
            <option value="">Select a category</option>
            {categories.map((cat) => (
  <option key={cat._id} value={cat._id}>
    {cat.name}
  </option>
))}

          </select>
        </div>

        {/* Images */}
        <div className="mb-3">
          <label className="form-label fw-semibold">Product Images</label>
          <input
            type="file"
            className="form-control"
            name="images"
            onChange={handleFileChange}
            multiple
            accept="image/*"
          />
        </div>

        {/* Image Preview */}
        {previewImages.length > 0 && (
          <div className="d-flex flex-wrap gap-2 mb-3">
            {previewImages.map((src, index) => (
              <img
                key={index}
                src={src}
                alt="Preview"
                className="img-thumbnail"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            ))}
          </div>
        )}

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? "Adding..." : "Add Product"}
        </button>
      </form>
    </div>
  );
};

export default AddProduct;
